import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { Create } from 'react-admin'
import BaseProductForm from 'ui-shared/Forms/BaseProductForm'

const RentCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <BaseProductForm />
      </Create>
    </SectionWrapper>
  )
}

export default RentCreate
